(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4710],{

/***/ 40751:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/create-event/notifications",
      function () {
        return __webpack_require__(97150);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 97150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ notifications; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/base/Box.tsx
var Box = __webpack_require__(51773);
// EXTERNAL MODULE: ./components/inputs/Button.tsx
var Button = __webpack_require__(11390);
// EXTERNAL MODULE: ./components/base/Modal.tsx
var Modal = __webpack_require__(18860);
// EXTERNAL MODULE: ./graphql/__generated/graphql.ts
var graphql = __webpack_require__(68240);
// EXTERNAL MODULE: ./layouts/CreateEventLayout.tsx + 6 modules
var CreateEventLayout = __webpack_require__(67526);
// EXTERNAL MODULE: ./libs/CreateEvent/useEventEditor.tsx + 6 modules
var useEventEditor = __webpack_require__(25687);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/base/Table.tsx
var Table = __webpack_require__(45672);
// EXTERNAL MODULE: ./components/event/TableRowActions.tsx
var TableRowActions = __webpack_require__(29033);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./components/email-builder/index.tsx
var email_builder = __webpack_require__(79656);
// EXTERNAL MODULE: ./components/email-builder/emailbuilder.type.ts
var emailbuilder_type = __webpack_require__(88378);
// EXTERNAL MODULE: ./components/email-builder/emailPreview.tsx + 1 modules
var emailPreview = __webpack_require__(51062);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js + 1 modules
var useMutation = __webpack_require__(72742);
// EXTERNAL MODULE: ./graphql/__generated/index.ts + 1 modules
var _generated = __webpack_require__(66703);
;// CONCATENATED MODULE: ./graphql/events/triggerEmailEvent.ts

const TRIGGER_EVENT_EMAIL = (0,_generated/* graphql */.B)("\n  mutation triggerEventEmail($eventId: String!, $template: String!) {\n    triggerEventEmail(eventId: $eventId, emailTemplate: $template)\n  }\n");

;// CONCATENATED MODULE: ./libs/CreateEvent/emailScheduling.ts
var ref;
const normalizedTitle = (title)=>{
    return (ref = title === null || title === void 0 ? void 0 : title.trim().toLowerCase()) !== null && ref !== void 0 ? ref : "";
};
/**
 * Compatibility only for schedules created before schedules were embedded in
 * email templates. New schedules must never use title as identity.
 */ const findLegacyEmailSchedule = (notifications, templateTitle)=>{
    const title = normalizedTitle(templateTitle);
    if (!title) return undefined;
    return notifications === null || notifications === void 0 ? void 0 : notifications.find((notification)=>normalizedTitle(notification.title) === title);
};
const removeLegacyEmailSchedule = (param)=>{
    let { notifications =[] , templateTitle , timestamp  } = param;
    const title = normalizedTitle(templateTitle);
    if (!title && !timestamp) return [
        ...notifications !== null && notifications !== void 0 ? notifications : []
    ];
    return (notifications !== null && notifications !== void 0 ? notifications : []).filter((notification)=>!(normalizedTitle(notification.title) === title && (!timestamp || notification.timestamp === timestamp)));
};

// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(57632);
// EXTERNAL MODULE: ./libs/EventTime/index.ts + 26 modules
var EventTime = __webpack_require__(26647);
;// CONCATENATED MODULE: ./pages/create-event/notifications.tsx



















const NotificationsForm = ()=>{
    var ref, ref1;
    const { formData , setFormData , errors , setErrors , refetchEvent  } = (0,useEventEditor/* useEventEditor */.O)();
    const [showEmailModal, setShowEmailModal] = (0,react.useState)(false);
    const [triggerMail] = (0,useMutation/* useMutation */.D)(TRIGGER_EVENT_EMAIL);
    const [emailModalData, setEmailModalData] = (0,react.useState)({});
    // const [errors, setErrors] = useState<ErrorType | undefined>(undefined)
    const errorHandler = function(id) {
        let alert = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return (message, testId)=>{
            const payload = [
                ...errors
            ];
            const hasError = !!message || message !== "";
            const isCleared = payload.find((f)=>f.eleId === testId) && !hasError;
            if (isCleared) return setErrors(payload.filter((f)=>f.eleId !== testId));
            const isDuplicate = !!payload.find((p)=>p.eleId === testId);
            const newError = {
                step: id !== null && id !== void 0 ? id : "unknown",
                message,
                eleId: testId,
                alert
            };
            if (!isDuplicate && hasError) setErrors([
                ...payload,
                newError
            ]);
        };
    };
    const emailBuilderModal = (0,react.useMemo)(()=>{
        var ref;
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            show: showEmailModal,
            setShow: setShowEmailModal,
            title: "".concat((emailModalData === null || emailModalData === void 0 ? void 0 : emailModalData.editIndex) !== undefined || emailModalData.editIndex === 0 ? "Edit" : "Create", " Email"),
            className: "flex overflow-visible w-full flex-col justify-between",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(email_builder/* default */.ZP, {
                    onSubmit: (data)=>{
                        console.log({
                            data
                        });
                        setEmailModalData(data);
                    },
                    enablePreview: true,
                    setError: errorHandler("email_builder"),
                    template: emailModalData
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    className: "mb-4 ml-auto",
                    title: emailModalData.trigger === emailbuilder_type/* SCHEDULED_EMAIL_TRIGGER */.Q ? "Schedule Email" : "Save Email",
                    type: "primary",
                    disabled: emailModalData.trigger === emailbuilder_type/* SCHEDULED_EMAIL_TRIGGER */.Q && (!((ref = emailModalData.schedule) === null || ref === void 0 ? void 0 : ref.runAt) || !moment_default()(emailModalData.schedule.runAt).isAfter(moment_default()())),
                    onClick: (e)=>{
                        var ref;
                        e.preventDefault();
                        console.log({
                            templates: formData === null || formData === void 0 ? void 0 : formData.emailTemplates,
                            emailModalData
                        });
                        var ref1;
                        let payload = {
                            ...formData,
                            emailTemplates: [
                                ...(ref1 = formData === null || formData === void 0 ? void 0 : formData.emailTemplates) !== null && ref1 !== void 0 ? ref1 : []
                            ]
                        };
                        const hasRegistrationConfirmationTemplate = !!(payload === null || payload === void 0 ? void 0 : (ref = payload.emailTemplates) === null || ref === void 0 ? void 0 : ref.find((f)=>f.trigger === graphql/* EventEmailTrigger.Confirmation */.bQ.Confirmation));
                        const newEmail = {
                            templateId: emailModalData.templateId || (0,v4/* default */.Z)(),
                            title: emailModalData.title,
                            enabled: true,
                            trigger: emailModalData.trigger,
                            data: emailModalData.data,
                            content: emailModalData.content,
                            schedule: emailModalData.trigger === emailbuilder_type/* SCHEDULED_EMAIL_TRIGGER */.Q ? emailModalData.schedule : undefined
                        };
                        if (!payload.emailTemplates) payload.emailTemplates = [];
                        if (newEmail.trigger === graphql/* EventEmailTrigger.Confirmation */.bQ.Confirmation && hasRegistrationConfirmationTemplate) payload = {
                            ...payload,
                            emailTemplates: [
                                ...payload.emailTemplates.map((template)=>template.trigger === graphql/* EventEmailTrigger.Confirmation */.bQ.Confirmation ? {
                                        ...template,
                                        trigger: graphql/* EventEmailTrigger.Manual */.bQ.Manual
                                    } : template)
                            ]
                        };
                        if (!!payload.emailTemplates) {
                            if (emailModalData.editIndex === 0 || emailModalData.editIndex) payload.emailTemplates[emailModalData.editIndex] = newEmail;
                            else payload.emailTemplates.push(newEmail);
                        }
                        if (emailModalData.legacyScheduleTimestamp) payload.notifications = removeLegacyEmailSchedule({
                            notifications: payload.notifications,
                            templateTitle: emailModalData.originalTitle,
                            timestamp: emailModalData.legacyScheduleTimestamp
                        });
                        console.log({
                            payload
                        });
                        setFormData(payload);
                        (0,email_builder/* clearEmailContentCache */.ok)({
                            type: "event",
                            scopeId: formData === null || formData === void 0 ? void 0 : formData.eventId,
                            template: emailModalData
                        });
                        setShowEmailModal(false);
                        setEmailModalData({});
                    }
                })
            ]
        });
    }, [
        formData,
        showEmailModal,
        emailModalData
    ]);
    const [actionLoading, setActionLoading] = (0,react.useState)(false);
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            emailBuilderModal,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "size-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        className: "flex items-center space-x-2 mb-4 mt-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: "text-xl",
                                children: "Emails"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                onClick: ()=>{
                                    var ref, ref1;
                                    var ref2, ref3;
                                    setEmailModalData({
                                        title: "Email Template ".concat((ref2 = formData === null || formData === void 0 ? void 0 : (ref = formData.emailTemplates) === null || ref === void 0 ? void 0 : ref.length) !== null && ref2 !== void 0 ? ref2 : 1),
                                        trigger: ((ref3 = formData === null || formData === void 0 ? void 0 : (ref1 = formData.emailTemplates) === null || ref1 === void 0 ? void 0 : ref1.length) !== null && ref3 !== void 0 ? ref3 : 0) > 0 ? graphql/* EventEmailTrigger.Manual */.bQ.Manual : graphql/* EventEmailTrigger.Confirmation */.bQ.Confirmation
                                    });
                                    setShowEmailModal(true);
                                },
                                title: "Create New Email",
                                type: "secondary",
                                size: "small"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* default */.Z, {
                        sortable: true,
                        items: (ref2 = formData === null || formData === void 0 ? void 0 : formData.emailTemplates) !== null && ref2 !== void 0 ? ref2 : undefined,
                        onSort: (e)=>{
                            console.log({
                                e
                            });
                            const payload = {
                                ...formData,
                                emailTemplates: e
                            };
                            setFormData(payload);
                        },
                        tableHeading: [
                            "Subject",
                            "Delivery",
                            "Status / time",
                            ""
                        ],
                        rows: formData === null || formData === void 0 ? void 0 : (ref = formData.emailTemplates) === null || ref === void 0 ? void 0 : ref.map((emailTemplates, index)=>{
                            var ref, ref1, ref2;
                            const legacySchedule = emailTemplates.schedule ? undefined : findLegacyEmailSchedule(formData.notifications, emailTemplates.title);
                            var ref3;
                            const scheduleStatus = (ref3 = (ref = emailTemplates.schedule) === null || ref === void 0 ? void 0 : ref.status) !== null && ref3 !== void 0 ? ref3 : legacySchedule === null || legacySchedule === void 0 ? void 0 : legacySchedule.status;
                            var ref4;
                            const scheduledAt = (ref4 = (ref1 = emailTemplates.schedule) === null || ref1 === void 0 ? void 0 : ref1.runAt) !== null && ref4 !== void 0 ? ref4 : legacySchedule === null || legacySchedule === void 0 ? void 0 : legacySchedule.timestamp;
                            const isScheduled = emailTemplates.trigger === emailbuilder_type/* SCHEDULED_EMAIL_TRIGGER */.Q && !!emailTemplates.schedule || !!legacySchedule;
                            var ref5;
                            return [
                                (ref5 = emailTemplates === null || emailTemplates === void 0 ? void 0 : (ref2 = emailTemplates.title) === null || ref2 === void 0 ? void 0 : ref2.toUpperCase()) !== null && ref5 !== void 0 ? ref5 : "No Title (".concat(index, ")"),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "rounded-md capitalize",
                                    children: isScheduled ? "Scheduled send" : emailTemplates.trigger
                                }, "notification-delivery-".concat(index)),
                                isScheduled ? "".concat(scheduleStatus === graphql/* NotificationStatus.Sent */.Ez.Sent ? "Sent" : scheduleStatus === graphql/* NotificationStatus.Failed */.Ez.Failed ? "Failed" : "Scheduled for", " ").concat((0,EventTime/* formatEventInstant */.g6)(scheduledAt, "D MMMM YYYY, h:mm A", formData.event)) : emailTemplates.sentDateTime ? moment_default()(emailTemplates.sentDateTime).format("D MMMM YYYY, h:mm A").toString() : emailTemplates.trigger === graphql/* EventEmailTrigger.Manual */.bQ.Manual ? "Not sent" : "On registration",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableRowActions/* default */.Z, {
                                    action: [
                                        {
                                            title: "Send",
                                            show: emailTemplates.trigger === graphql/* EventEmailTrigger.Manual */.bQ.Manual && !isScheduled,
                                            loading: actionLoading,
                                            onClicked: ()=>{
                                                if (!!formData.eventId && !!emailTemplates.title) {
                                                    setActionLoading(true);
                                                    triggerMail({
                                                        variables: {
                                                            eventId: formData.eventId,
                                                            template: emailTemplates.title
                                                        }
                                                    }).then(()=>{
                                                        refetchEvent();
                                                    }).finally(()=>setActionLoading(false));
                                                }
                                            },
                                            confirmModal: {
                                                title: "Are you sure?",
                                                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                    className: "pt-6 pb-6",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                            className: "my-2 mb-6",
                                                            children: "Are you sure you want to send this email to all attendees? Please ensure your email template is correct before confirming."
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                            className: "h-[50vh]",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(emailPreview/* EmailPreview */.M, {
                                                                resizeEnabled: false,
                                                                content: emailTemplates.content
                                                            })
                                                        })
                                                    ]
                                                })
                                            }
                                        },
                                        {
                                            title: "Duplicate",
                                            show: emailTemplates.trigger !== graphql/* EventEmailTrigger.Confirmation */.bQ.Confirmation,
                                            loading: actionLoading,
                                            onClicked: ()=>{
                                                if (!!formData.eventId && !!emailTemplates.title) {
                                                    var ref;
                                                    setActionLoading(true);
                                                    const targetTemplate = (ref = formData.emailTemplates) === null || ref === void 0 ? void 0 : ref.find((f)=>f.title === emailTemplates.title);
                                                    if (targetTemplate) {
                                                        const { templateId: _templateId , schedule: _schedule , ...templateCopy } = targetTemplate;
                                                        var _emailTemplates;
                                                        setFormData({
                                                            ...formData,
                                                            emailTemplates: [
                                                                ...(_emailTemplates = formData.emailTemplates) !== null && _emailTemplates !== void 0 ? _emailTemplates : [],
                                                                {
                                                                    ...templateCopy,
                                                                    title: "".concat(targetTemplate.title, " - Copy"),
                                                                    trigger: graphql/* EventEmailTrigger.Manual */.bQ.Manual
                                                                }
                                                            ]
                                                        });
                                                    }
                                                    setActionLoading(false);
                                                }
                                            }
                                        }
                                    ],
                                    editClicked: ()=>{
                                        console.log({
                                            emailTemplates,
                                            index
                                        });
                                        var _trigger, _status, _schedule, _title, ref;
                                        setEmailModalData({
                                            ...emailTemplates,
                                            editIndex: index,
                                            trigger: isScheduled ? emailbuilder_type/* SCHEDULED_EMAIL_TRIGGER */.Q : (_trigger = emailTemplates.trigger) !== null && _trigger !== void 0 ? _trigger : graphql/* EventEmailTrigger.Manual */.bQ.Manual,
                                            schedule: (_schedule = emailTemplates.schedule) !== null && _schedule !== void 0 ? _schedule : legacySchedule && scheduledAt ? {
                                                scheduleId: "",
                                                runAt: scheduledAt,
                                                status: (_status = legacySchedule.status) !== null && _status !== void 0 ? _status : graphql/* NotificationStatus.Processing */.Ez.Processing
                                            } : undefined,
                                            originalTitle: legacySchedule ? (_title = emailTemplates.title) !== null && _title !== void 0 ? _title : undefined : undefined,
                                            legacyScheduleTimestamp: (ref = legacySchedule === null || legacySchedule === void 0 ? void 0 : legacySchedule.timestamp) !== null && ref !== void 0 ? ref : undefined
                                        });
                                        setShowEmailModal(true);
                                    },
                                    deleteClicked: emailTemplates.trigger !== graphql/* EventEmailTrigger.Confirmation */.bQ.Confirmation ? ()=>{
                                        var ref;
                                        setFormData({
                                            ...formData,
                                            emailTemplates: formData === null || formData === void 0 ? void 0 : (ref = formData.emailTemplates) === null || ref === void 0 ? void 0 : ref.filter((_, i)=>i !== index),
                                            notifications: removeLegacyEmailSchedule({
                                                notifications: formData.notifications,
                                                templateTitle: emailTemplates.title,
                                                timestamp: legacySchedule === null || legacySchedule === void 0 ? void 0 : legacySchedule.timestamp
                                            })
                                        });
                                    } : undefined
                                }, index)
                            ];
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        show: (formData === null || formData === void 0 ? void 0 : (ref1 = formData.emailTemplates) === null || ref1 === void 0 ? void 0 : ref1.length) === 0,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                            className: "text-sm mt-8 text-center mb-8",
                            children: "No event emails have been created yet"
                        })
                    })
                ]
            })
        ]
    });
};
NotificationsForm.Layout = CreateEventLayout/* default */.Z;
/* harmony default export */ var notifications = (NotificationsForm);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4617,3777,3714,1458,9198,474,4555,1209,7632,9681,6109,9041,8012,9265,788,5687,7526,9460,7585,9774,2888,179], function() { return __webpack_exec__(40751); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);